import { Stack, Grid } from '@mui/material';
import { Arms } from './Arms';
import { useState } from 'react';
import { Switch, FormControlLabel } from '@mui/material';
import { ArmsExt } from './ArmsExt';
import { ArmsVideo } from './ArmsVideo';
import { ArmPitch } from './ArmPitch';

export function ArmsCombined({ armsData, deviceDescription, model1Result, test }) {
  
  const [showExternalSensor, setShowExternalSensor] = useState(false);

  const pitchDataLeft = () => {
    return armsData.armMovementExtSensor?.left?.attitude.map((a) => quaternionToPitch(a));
  };

  const pitchDataRight = () => {
    return armsData.armMovementExtSensor?.right?.attitude.map((a) => quaternionToPitch(a));
  };

  const quaternionToPitch = (quaternion) => {
    const { x, y, z, w } = quaternion;
    const sinp = 2 * (w * y - z * x);
    // Check for gimbal lock (when sinp is outside the range of -1 to 1)
    if (Math.abs(sinp) >= 1) {
      return Math.sign(sinp) * (Math.PI / 2); // Use 90 degrees if out of range
    } else {
      return Math.asin(sinp);
    }
  };

  return (
    <Stack>
      <FormControlLabel control={<Switch checked={showExternalSensor} onChange={() => setShowExternalSensor(!showExternalSensor)} />} label="Show External Sensor Data" />
      {showExternalSensor ? <ArmsExt armsData={armsData} deviceDescription={deviceDescription}/> : <Arms armsData={armsData} deviceDescription={deviceDescription} model1Result={model1Result}/>}
      <Grid container sx={{ overflowX: 'scroll', overflowY: 'scroll' }}>
        {armsData && <ArmPitch title="Left Arm Pitch" armResult="{testDetails.armsResult.leftArmResult}" armsPitchData={pitchDataLeft()} />}
        {armsData && <ArmPitch title="Right Arm Pitch" armResult="{testDetails.armsResult.leftArmResult}" armsPitchData={pitchDataRight()} />}
      </Grid>
      {/* <ResultCard title="RIGHT ARM">{arms && <ArmTest armResult="{testDetails.armsResult.leftArmResult}" armsPitchData={pitchDataRight()} />}</ResultCard> */}
      <ArmsVideo test={test} />
    </Stack>
  );
}
